import axios from 'axios'

// Create Axios instance with default configuration
const api = axios.create({
  baseURL: '/',
  timeout: import.meta.env.VITE_API_TIMEOUT || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add any auth tokens here if needed
    // const token = localStorage.getItem('auth_token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    if (error.response?.status === 401) {
      // Handle unauthorized
      localStorage.removeItem('auth_token')
      localStorage.removeItem('admin_token')
      window.location.href = '/admin/login'
    }

    if (error.response?.status === 500) {
      console.error('Server error:', error.response.data)
    }

    return Promise.reject(error)
  }
)

// API methods
export const bookCleaningSlot = async (data) => {
  return api.post('/api/book-slot', data)
}

export const registerVolunteer = async (data) => {
  return api.post('/api/become-volunteer', data)
}

export const becomeVolunteer = async (data) => {
  return api.post('/become-volunteer', data)
}

export const fetchPublicImpactStats = async () => {
  return api.get('/api/public/impact-stats')
}

export const fetchPublicHeritagePlaces = async () => {
  return api.get('/api/public/heritage-places')
}

export const fetchPublicGallery = async () => {
  return api.get('/api/public/gallery')
}

export const fetchPublicLeaderboard = async () => {
  return api.get('/api/public/leaderboard')
}

export const subscribeNewsletter = async (email) => {
  return api.post('/api/newsletter/subscribe', { email })
}

// Admin API methods
export const adminLogin = async (credentials) => {
  return api.post('/api/admin/login', credentials)
}

const getAdminConfig = () => {
  const token = localStorage.getItem('admin_token')
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  }
}

export const fetchAdminStats = async () => {
  return api.get('/api/admin/stats', getAdminConfig())
}

export const fetchAdminVolunteers = async () => {
  return api.get('/api/admin/volunteers', getAdminConfig())
}

export const fetchAdminCleaningSlots = async () => {
  return api.get('/api/admin/cleaning-slots', getAdminConfig())
}

export const fetchAdminMissions = async () => {
  return api.get('/api/admin/missions', getAdminConfig())
}

export const fetchAdminImpactStats = async () => {
  return api.get('/api/admin/records/impact_stats', getAdminConfig())
}

export const fetchAdminHeritagePlaces = async () => {
  return api.get('/api/admin/records/heritage_places', getAdminConfig())
}

export const fetchAdminGalleryItems = async () => {
  return api.get('/api/admin/records/gallery_items', getAdminConfig())
}

export const fetchAdminNewsletters = async () => {
  return api.get('/api/admin/records/newsletters', getAdminConfig())
}

export const fetchAdminLeaderboard = async () => {
  return api.get('/api/admin/records/leaderboard', getAdminConfig())
}

export const createAdminRecord = async (table, data) => {
  return api.post(`/api/admin/records/${table}`, data, getAdminConfig())
}

export const updateAdminRecord = async (table, id, data) => {
  return api.put(`/api/admin/records/${table}/${id}`, data, getAdminConfig())
}

export const deleteAdminRecord = async (table, id) => {
  return api.delete(`/api/admin/records/${table}/${id}`, getAdminConfig())
}

export default api
